module.exports = __webpack_public_path__ + "img/propertyBanner.63cc53aa.png";